// extracted by mini-css-extract-plugin
export var dropdownButton = "_2x-0";
export var fullWidthDropdownButton = "_2x-1";
export var icon = "_2x-3";
export var iconPlaceholder = "_2x-2";
export var shortcutContainer = "_2x-4";